import { QuestionGeoLocation } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/geo-location/geo-location";

import { useRoomGeoLocation } from "./hooks";

export const QuestionRoomGeoLocation = () => {
	const { isEdited, hasError, geoLocation, onSetLatitude, onSetLongitude } = useRoomGeoLocation();

	return (
		<QuestionGeoLocation
			isEdited={isEdited}
			hasError={hasError}
			geoLocation={geoLocation}
			onSetLatitude={onSetLatitude}
			onSetLongitude={onSetLongitude}
		/>
	);
};

QuestionRoomGeoLocation.displayName = "QuestionRoomGeoLocation";
